import styled from 'styled-components';

const ChoiceWrap = styled.div`
    padding-bottom: 1.5rem;
`;

export default ChoiceWrap;